import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";

const NameNavigation = ({ currentIndex, setCurrentIndex, motorcycles }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      const selectedButton = scrollRef.current.children[currentIndex];
      if (selectedButton) {
        selectedButton.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    }
  }, [currentIndex]);

  return (
    <div className="relative w-full bg-black overflow-hidden h-16">
      <div
        ref={scrollRef}
        className="flex overflow-x-auto no-scrollbar snap-x snap-mandatory px-4 w-full gap-4 items-center h-full"
      >
        {motorcycles.map((motorcycle, index) => (
          <motion.button
            key={motorcycle.name}
            className={`
              font-['Guardian_Sans_XCond']
              text-[20px]
              leading-[24px]
              tracking-[0.02em]
              font-semibold
              px-4 
              py-3 
              mx-2 
              flex-shrink-0 
              transition-all 
              duration-300 
              ease-in-out 
              rounded-full 
              snap-center
              items-center
              ${currentIndex === index ? "text-white" : "text-gray-500"}
            `}
            onClick={() => setCurrentIndex(index)}
            whileHover={{
              scale: 1.05,
              y: 0
            }}
            whileTap={{
              scale: 0.95,
              y: 0
            }}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
              scale: currentIndex === index ? 1.05 : 1,
              y: 0
            }}
            transition={{
              duration: 0.3,
              delay: index * 0.05,
            }}
          >
            {motorcycle.name}
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default NameNavigation;